import Modal from 'components/Modal'
import IcashRedemptionTx from 'views/MemberProfile/ManualTx/IcashRedemptionTx'

type Props = {
  title: string | undefined
  open: boolean
  onClose: () => void
}

const ModalIcashRedemptionTx = ({
  title,
  open,
  onClose,
}: Props): JSX.Element => {
  return (
    <Modal open={open} title={title} onClose={onClose} noFooter>
      <IcashRedemptionTx onClose={onClose} />
    </Modal>
  )
}

export default ModalIcashRedemptionTx
